import { render } from "./Dashboard2.vue?vue&type=template&id=06d398de"
import script from "./Dashboard2.vue?vue&type=script&lang=js"
export * from "./Dashboard2.vue?vue&type=script&lang=js"

import "./Dashboard2.vue?vue&type=style&index=0&id=06d398de&sass=true&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__